import { render } from "./Userbar.vue?vue&type=template&id=41927124&scoped=true"
import script from "./Userbar.vue?vue&type=script&lang=js"
export * from "./Userbar.vue?vue&type=script&lang=js"

import "./Userbar.vue?vue&type=style&index=0&id=41927124&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41927124"]])

export default __exports__